import { render } from "./AppServerConfigInfo.vue?vue&type=template&id=627d08aa&ts=true"
import script from "./AppServerConfigInfo.vue?vue&type=script&lang=ts"
export * from "./AppServerConfigInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__